<script lang="ts">
	import { browser } from "$app/environment";

	let cookieBannerShown: boolean = browser && localStorage.getItem("cookieBannerShown") === "true";

	const setCookieBannerShown = () => {
		localStorage.setItem("cookieBannerShown", "true");
		localStorage.setItem("cookieConsent", "true");
		cookieBannerShown = true;
	};

	$: cookieBannerShown;
</script>

{#key cookieBannerShown}
	{#if !cookieBannerShown}
		<div
			class="pointer-events-none fixed inset-x-0 bottom-0 px-6 pb-6 animate-appearFromBottom z-50"
		>
			<div
				class="pointer-events-auto ml-auto max-w-xl rounded-xl bg-white p-6 shadow-lg ring-1 ring-gray-200/10"
			>
				<p class="text-sm leading-6 text-gray-900">
					Less Waste uses cookies to provide necessary site functionality and improve your
					experience. By using our website, you agree to our privacy policy and our cookie policy.
					See our <a href="/privacy" class="font-semibold text-opal">privacy policy</a>.
				</p>
				<div class="mt-4 flex items-center gap-x-5">
					<button
						on:click={() => setCookieBannerShown()}
						type="button"
						class="rounded-md bg-opal px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opal-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900"
						>Accept all</button
					>
				</div>
			</div>
		</div>
	{/if}
{/key}
